import apiClient from './api.service';

export interface InspectionPointLibrary {
  id: string;
  company_id: string;
  code: string;
  name: string;
  category: string;
  inspection_type?: string;
  description?: string;
  required_qualification?: string;
  standard_reference?: string;
  documentation_requirements?: string;
  is_active: boolean;
  is_deleted: boolean;
  created_at: string;
}

export interface InspectionPointFilters {
  category?: string;
  search?: string;
  is_active?: boolean;
}

class InspectionPointLibraryService {
  async getAll(filters?: InspectionPointFilters): Promise<InspectionPointLibrary[]> {
    const response = await apiClient.get('/quality/inspection-points', { params: filters });
    return response.data || [];
  }

  async getByCategory(category: string): Promise<InspectionPointLibrary[]> {
    const response = await apiClient.get(`/quality/inspection-points/category/${category}`);
    return response.data || [];
  }

  async getById(id: string): Promise<InspectionPointLibrary> {
    const response = await apiClient.get(`/quality/inspection-points/${id}`);
    return response.data;
  }

  async create(data: Partial<InspectionPointLibrary>): Promise<InspectionPointLibrary> {
    const response = await apiClient.post('/quality/inspection-points', data);
    return response.data;
  }

  async update(id: string, data: Partial<InspectionPointLibrary>): Promise<InspectionPointLibrary> {
    const response = await apiClient.put(`/quality/inspection-points/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/quality/inspection-points/${id}`);
  }
}

const inspectionPointLibraryService = new InspectionPointLibraryService();
export default inspectionPointLibraryService;
export { inspectionPointLibraryService };
